import { MetricCardTemplate, MetricCardTemplateProps } from "./template";

export type MetricCardProps = MetricCardTemplateProps;

export const MetricCard = (props: MetricCardProps): JSX.Element => {
  return <MetricCardTemplate {...props} />;
};
